'use strict';

function buildWasabiTransferInput({
  sourceUri,
  endpointUrl,
  accessKeyId,
  secretAccessKey,
}) {
  return {
    sourceUri,
    endpointUrl,
    credentials: {
      accessKeyId,
      secretAccessKey,
    },
  };
}

module.exports = { buildWasabiTransferInput };
